import Vue from "vue";
import Vuetify from "vuetify/lib";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        current: "en"
    },
    icons: {
        iconfont: "md"
    },
    theme: {
        themes: {
            light: {
                primary: "#004C93",
                secondary: "#56BDEE",
            }
        }
    }
});
